<p-toast position="top-right" key="sync-error"></p-toast>

<p-dialog (onHide)="locationName =''; locationGid = ''; corporationGid =''"
          (onShow)="locationName =''; locationGid = ''; corporationGid =''" [(visible)]="visibleLocationDialog"
          header="Add Customer" [modal]="true" [blockScroll]="true"
          [style]="{width: '30%'}">
    <div>
        <div class="p-grid p-ai-center">
            <div class="p-col-12">
                <div class="p-field">
                    <label>Location Gid</label>
                    <input type="text" [(ngModel)]="locationGid" placeholder="Enter..." pInputText class="width-100">
                </div>
            </div>
        </div>

        <div class="p-grid">
            <div class="p-col-12">
                <div class="p-field">
                    <label>Corporation Gid</label>
                    <input type="text" [(ngModel)]="corporationGid" readonly pInputText class="width-100">
                </div>
            </div>
        </div>

        <div class="p-grid">
            <div class="p-col-12">
                <div class="p-field">
                    <label>Location Name</label>
                    <input type="text" [(ngModel)]="locationName" readonly pInputText class="width-100">
                </div>
            </div>
        </div>

        <div class="p-grid p-jc-end">
            <div class="p-col-12 p-text-right">
                <div class="p-d-flex p-ai-center p-jc-end">
                    <div>
                        <i *ngIf="isAddingLocation" class="pi pi-spin pi-spinner p-text-secondary"
                           style="font-size: 1.25rem"></i>
                    </div>
                    <div class="p-ml-2">
                        <button pButton pRipple [disabled]="isAddingLocation" label="Add" (click)="onAddOfCustomer()"
                                class="p-button-secondary"></button>
                    </div>

                </div>
            </div>
        </div>

    </div>
</p-dialog>


<div class="p-mt-5">

    <div class="card">

        <div class="p-grid divider-bottom">
            <div class="p-col-12 p-text-left">
                <h5 class="p-m-0 p-text-primary">Customer Onboarding</h5>
            </div>
        </div>

        <div class="p-grid p-mt-3 p-jc-end">
            <div class="p-col-3">
                <div class="preview-message">
                    <div>
                        Bookings Last 3 months
                    </div>
                    <div class="p-pt-3">
                        Invoices Last 3 months
                    </div>
                    <div class="p-pt-3">
                        SOA Current Dated
                    </div>
                </div>
            </div>
        </div>

        <div class="p-mt-3 p-grid">
            <div class="p-col-4">
                <div class="p-field">
                    <label class="p-text-secondary">Customer</label>
                    <p-dropdown #customerDropdown (onShow)="getBusinessEntity()" [(ngModel)]="selectedBusinessEntity"
                                [options]="businessEntity"
                                optionLabel="name"
                                optionValue="businessEntityId"
                                [showClear]="true"
                                filterBy="name"
                                emptyMessage="No Business Entity Found" [filter]="true" appendTo="body"
                                placeholder="Select...">
                        <ng-template pTemplate="items" let-entity>
                            {{entity?.name ? entity?.name : '-'}}
                        </ng-template>
                        <ng-template pTemplate="footer">

                            <button (click)="customerDropdown.hide(); visibleLocationDialog = true" pButton pRipple
                                    class="p-button-text width-100 p-text-left"
                                    label="Add New"></button>

                        </ng-template>
                    </p-dropdown>
                </div>
            </div>
        </div>

        <div class="p-grid">
            <div class="p-col-12">
                <div class="p-d-flex p-ai-center">
                    <button (click)="importData('bookings')" [disabled]="!importBookings" pButton pRipple
                            label="Import Bookings" class="p-button-secondary"
                            style="min-width: 12vw"></button>
                    <!--                    <div class="p-ml-2" *ngIf="isBookingsImporting">-->
                    <!--                        <i class="pi pi-spin pi-spinner p-text-secondary" style="font-size: 1.25rem"></i> <span-->
                    <!--                            class="p-ml-2">Importing Bookings....</span>-->
                    <!--                    </div>-->
                    <div class="p-ml-2" *ngIf="bookingsSucceed?.succeed">
                        {{bookingsSucceed?.message ? bookingsSucceed?.message : '-'}}
                    </div>
                </div>
            </div>
            <div class="p-col-12">
                <div class="p-d-flex p-ai-center">
                    <button (click)="importData('invoices')" [disabled]="!importInvoices" pButton pRipple
                            label="Import Invoices" class="p-button-secondary"
                            style="min-width: 12vw"></button>
                    <!--                    <div class="p-ml-2" *ngIf="isInvoicesImporting">-->
                    <!--                        <i class="pi pi-spin pi-spinner p-text-secondary" style="font-size: 1.25rem"></i> <span-->
                    <!--                            class="p-ml-2">Importing Invoices....</span>-->
                    <!--                    </div>-->
                    <div class="p-ml-2" *ngIf="invoicesSucceed?.succeed">
                        {{invoicesSucceed?.message ? invoicesSucceed?.message : '-'}}
                    </div>
                </div>
            </div>
            <div class="p-col-12">
                <div class="p-d-flex p-ai-center">
                    <button (click)="importData('soa')" [disabled]="!importSOA" pButton pRipple label="Import SOA"
                            class="p-button-secondary"
                            style="min-width: 12vw"></button>
                    <!--                    <div class="p-ml-2" *ngIf="isSoaImporting">-->
                    <!--                        <i class="pi pi-spin pi-spinner p-text-secondary" style="font-size: 1.25rem"></i> <span-->
                    <!--                            class="p-ml-2">Importing SOA....</span>-->
                    <!--                    </div>-->
                    <div class="p-ml-2" *ngIf="soaSucceed?.succeed">
                        {{soaSucceed?.message ? soaSucceed?.message : '-'}}
                    </div>
                </div>
            </div>
        </div>

    </div>


</div>
